/**
 * useAdminPrefs - Hook for layout/visible_modules preferences synced to backend.
 */
import { useState, useEffect, useCallback } from "react";
import axios from "axios";
import { BACKEND_URL } from "../../../config/api";

const API_ADMIN = (BACKEND_URL || "") + "/api";

export function useAdminPrefs() {
  const [prefs, setPrefs] = useState(() => {
    try {
      const s = localStorage.getItem("admin_prefs");
      return s ? JSON.parse(s) : { layout: "sidebar", visible_modules: null };
    } catch { return { layout: "sidebar", visible_modules: null }; }
  });

  useEffect(() => {
    axios.get(`${API_ADMIN}/admin/settings`, { withCredentials: true })
      .then(r => {
        const ap = r.data?.admin_prefs;
        if (ap) setPrefs(p => {
          const merged = { ...p, ...ap };
          localStorage.setItem("admin_prefs", JSON.stringify(merged));
          return merged;
        });
      }).catch(() => {});
  }, []);

  const updatePrefs = useCallback((updates) => {
    setPrefs(p => {
      const next = { ...p, ...updates };
      localStorage.setItem("admin_prefs", JSON.stringify(next));
      axios.get(`${API_ADMIN}/admin/settings`, { withCredentials: true })
        .then(r => {
          axios.put(`${API_ADMIN}/admin/settings`, { ...r.data, admin_prefs: next }, { withCredentials: true }).catch(() => {});
        }).catch(() => {});
      return next;
    });
  }, []);

  return { prefs, updatePrefs };
}
